<template>
  <button
    v-if="bookmarkable"
    :data-wptv="'banniere-'+ (bookmarked ? 'favoris-retirer' : 'favoris-ajouter')"
    :aria-label="bookmarked ? removeBookmarksLabel : addBookmarksLabel"
    type="button"
    class="btn-add-bookmark"
    @click="onSelectBookmark(item, bookmarkId, bookmarked)">
    <span
      :class="['icon', { 'icon-recommend': !bookmarked }, {'icon-relationship': bookmarked }]"
      :aria-hidden="true" />
    <span class="btn-add-bookmark-text">
      {{ bookmarked ? removeBookmarksLabel : addBookmarksLabel }}
    </span>
  </button>
</template>

<script>
import apiConstants from '../../../../../api.constants'
import BookmarksMixin from '../../../../shared/bookmarks/bookmarks.mixin'
import { mapGetters } from 'vuex'
import FipUtils from '../../fip.utils'
import _get from 'lodash/get'

export default {
  name: 'BookmarksButton',
  mixins: [
    BookmarksMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    },
    canBeBookmarked: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      getBookmarkById: 'bookmarks/getBookmarkById',
      applicationVariant: 'user/getApplicationVariant'
    }),
    bookmarkId () {
      return _get(this.getBookmarkById(this.item.id), 'bookmarkId', null)
    },
    bookmarked () {
      return this.bookmarkId !== null
    },
    aTesting () {
      return this.applicationVariant === apiConstants.ABTESTING.BOOKMARKS.VARIANTS.A
    },
    addBookmarksLabel () {
      return this.$t('fip.abTesting.variantA.addToListBookmarks')
    },
    removeBookmarksLabel () {
      return this.$t('fip.abTesting.variantA.removeFromListBookmarks')
    },
    isProspect () {
      return FipUtils.isProgramProspected(this.item)
    },
    bookmarkable () {
      return this.canBeBookmarked && !this.isProspect
    }
  }
}
</script>

<style lang="scss" scoped>
    .btn-add-bookmark {
      position: relative;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      z-index: 9;
      color: #ffffff;
      border: 0;
      background: none;
      box-shadow: none;
      @include mediaQueries('width', (xsmall: 100%, medium: auto));
      @include mediaQueries('margin-top', (xsmall: 30px, medium: 0));
      @include mediaQueries('margin-right', (xsmall: 0, medium: 30px));
      @include mediaQueries('justify-content', (xsmall: center, medium: flex-start));
      @extend %bold;
      @extend %focus-visible;

      .btn-add-bookmark-text {
        font-size: 16px;
        word-wrap: break-word;
        white-space: nowrap;

        &:hover {
          text-decoration: $primary underline;
        }
      }

      .icon {
        flex-grow: 0;
        font-size: 16px;
        margin-right: 10px;
      }

      &:hover {
        color: $primary;
      }
    }

</style>
